module.exports = __webpack_public_path__ + "static/media/PNT-PBTC.d10b2e69.svg";